export default "__VITE_ASSET__BAxAwUrH__"